import React from "react";
const LoaderSuspense = () => <p>Loading...</p>;
export default LoaderSuspense;
